import { combineReducers } from 'redux';
import data from './reducer';

const rootReducer = combineReducers({
    data
});

export default rootReducer;